/**
 * 校验工具类
 */

var validation = {};
// 数字类型可以有1到2位小数
validation.numberInt = /(^-?[0-9][0-9]*?)$/;
validation.number = /^[0-9]+(.[0-9]{1,2})?$/;
//手机号
validation.mobile = /^1(3|4|5|6|7|8|9)\d{9}$/;

//电话
validation.phone = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;

//身份证
validation.idCard = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;

///邮箱
validation.email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

// 邮编
validation.postcode = /[1-9]\d{5}(?!\d)/;

//internetUrl URL地址
validation.url = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;

// 姓名验证
validation.name = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;

//不能出现空格
validation.isEmpty = /^$| /;

//银行卡号
validation.bankCard = /^([1-9]{1})(\d{14}|\d{18})$/;

//车牌号
validation.carPlate = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[A-HJ-NP-Z])|([A-HJ-NP-Z]{1}([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}))$/;

//金钱
validation.money = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;

//组织机构
validation.OCC = /^[A-Z0-9]{8}-[A-Z0-9]$|^[A-Z0-9]{8}-[A-Z0-9]-[0-9]{2}$/;

//判断输入字符串得内容得长度
validation.strLength = (minLength, maxLength) => {
  return (rule, value, callback) => {
    if (value.length < minLength) {
      callback(new Error(`请输入至少${minLength}个字符!`));
    } else if (value.length > maxLength) {
      callback(new Error(`请输入至多${maxLength}个字符!`));
    } else {
      callback();
    }
  };
};

//判断输入数字大小区间
validation.numberSize = (min, max) => {
  return (rule, value, callback) => {
    if (typeof min == 'undefined' && min !== '-' && value.length < min) {
      callback(new Error(`请输入大于等于${minLength}数字!`));
    } else if (typeof min == 'undefined' && max !== '+' && value.length > max) {
      callback(new Error(`请输入小于等于${maxLength}数字!`));
    } else {
      callback();
    }
  };
};

//判断数字
validation.digit = (min = 1, max = 10) => {
  return (rule, value, cb) => {
    value = String(value);
    let temp = /^[1-9][0-9]*$/.test(value)
    if (!temp) {
      cb(new Error("请输入数字"))
    } else if (value.length < min) {
      cb(new Error("输入的数字太小"))
    } else if (value.length > max) {
      cb(new Error("输入的数字太大"))
    } else {
      cb()
    }
  };
};

validation.taxNo = () => {
  return (rule, value, cb) => {
    value = String(value);
    let temp = /^[\da-zA-Z]+$/.test(value);
    let len = value.length
    console.log('len==>',len);
    if ((len < 15) || (len>20)) {
      cb(new Error("格式错误"))
    } else if (!temp) {
      cb(new Error("格式错误"))
    } else {
      cb()
    }
  };
}

//判断两次输入是否相同
validation.isSame = (that, obj, key) => {
  return (rule, value, callback) => {
    if (value == '') {
      callback(new Error('请再次输入！'));
    } else if (value !== that[obj][key]) {
      callback(new Error('两次输入不一致!'));
    } else {
      callback();
    }
  };
};

/**
 * URL地址
 */
validation.validateUrl = () => {
  return (rule, value, callback) => {
    var reg = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;
    if (!reg.test(value)) {
      callback(new Error('请输入正确的URL！'));
    } else {
      callback();
    }
  };
};
/**
 * 手机号
 */
validation.validateMobile = () => {
  return (rule, value, callback) => {
    var reg = /^1[3456789]\d{9}$/;
    if (!reg.test(value)) {
      callback(new Error('请输入正确的手机号！'));
    } else {
      callback();
    }
  };
};
/**
 * 电话
 */
validation.validatePhone = () => {
  return (rule, value, callback) => {
    var reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
    if (!reg.test(value)) {
      callback(new Error('请输入正确的电话！'));
    } else {
      callback();
    }
  };
};
/**
 * 邮箱
 */
validation.validateEmail = () => {
  return (rule, value, callback) => {
    var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    if (!reg.test(value)) {
      callback(new Error('请输入正确的邮箱！'));
    } else {
      callback();
    }
  };
};

/**
 * 身份证
 */
validation.validateIdCard = () => {
  return (rule, value, callback) => {
    var reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    if (!reg.test(value)) {
      callback(new Error('请输入正确的身份证号！'));
    } else {
      callback();
    }
  };
};

/**
 * 车牌
 */
validation.validateCarPlate = () => {
  return (rule, value, callback) => {
    var reg = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[A-HJ-NP-Z])|([A-HJ-NP-Z]{1}([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}))$/;
    if (!reg.test(value)) {
      callback(new Error('请输入正确的车牌号！'));
    } else {
      callback();
    }
  };
};

/**
 * 组织机构代码
 */
validation.validateOCC = () => {
  return (rule, value, callback) => {
    var reg = /^[A-Z0-9]{8}-[A-Z0-9]$|^[A-Z0-9]{8}-[A-Z0-9]-[0-9]{2}$/;
    if (!reg.test(value)) {
      callback(new Error('请输入正确的组织机构码！'));
    } else {
      callback();
    }
  };
};

//金钱
validation.validateMoney = () => {
  return (rule, value, callback) => {
    var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
    if (!reg.test(value)) {
      callback(new Error('请输入正确的URL！'));
    } else {
      callback();
    }
  };
};
//金钱
validation.vMoney = () => {
  return function (rule, val, cb) {
    console.log('val==>', val);
    console.log('arguments==>', arguments);
    if (!/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(val)) {
      cb(new Error(`金额格式错误`))
    } else if ((val + "").length > 13) {
      cb(new Error(`金额过大`))
    } else {
      cb();
    }
  }
}

export var validation = validation;
